module.exports = __webpack_public_path__ + "public/images/chat-message-tale.0c42c4fdf88236b6c2bc8b6eaf18b0ff.svg";